var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalMinersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_7571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#6366F1",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_7571)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4167 30.5837H16.5834C15.663 30.5837 14.9167 29.8374 14.9167 28.917V13.0837C14.9167 12.1632 15.663 11.417 16.5834 11.417H24.4888C24.4897 11.417 24.4909 11.417 24.4917 11.417H24.5001C24.6334 11.417 24.7472 11.4841 24.8234 11.5816L28.9188 15.677C29.0167 15.7532 29.0834 15.867 29.0834 16.0003V16.0091C29.0834 16.0099 29.0834 16.0103 29.0834 16.0112V28.917C29.0834 29.8374 28.3372 30.5837 27.4167 30.5837ZM24.9167 12.8257V15.5837H27.6747L24.9167 12.8257ZM28.2501 16.417H24.5001C24.2697 16.417 24.0834 16.2303 24.0834 16.0003V12.2503H16.5834C16.1234 12.2503 15.7501 12.6237 15.7501 13.0837V28.917C15.7501 29.377 16.1234 29.7503 16.5834 29.7503H27.4167C27.8767 29.7503 28.2501 29.377 28.2501 28.917V16.417ZM25.7501 27.2503H18.2501C18.0197 27.2503 17.8334 27.0641 17.8334 26.8337C17.8334 26.6037 18.0197 26.417 18.2501 26.417H25.7501C25.9805 26.417 26.1667 26.6037 26.1667 26.8337C26.1667 27.0641 25.9805 27.2503 25.7501 27.2503ZM25.7501 23.917H18.2501C18.0197 23.917 17.8334 23.7307 17.8334 23.5003C17.8334 23.2703 18.0197 23.0837 18.2501 23.0837H25.7501C25.9805 23.0837 26.1667 23.2703 26.1667 23.5003C26.1667 23.7307 25.9805 23.917 25.7501 23.917ZM25.7501 20.5837H18.2501C18.0197 20.5837 17.8334 20.3974 17.8334 20.167C17.8334 19.937 18.0197 19.7503 18.2501 19.7503H25.7501C25.9805 19.7503 26.1667 19.937 26.1667 20.167C26.1667 20.3974 25.9805 20.5837 25.7501 20.5837Z",
    fill: "#6366F1",
    stroke: "#6366F1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_7571",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_7571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_7571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_7571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMinersIcon);
export default __webpack_public_path__ + "static/media/total-miners-icon.3a3a0a167bcc76c14dc5192e42dd828c.svg";
export { ForwardRef as ReactComponent };